import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';

import { IrisButtonModule } from '@sondermind/iris/button';

import { IrisIconComponent } from '@sondermind/iris/icon';
import { FAQAccordionComponent } from './components/faq-accordion.component';

@NgModule({
  declarations: [FAQAccordionComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    RouterModule,
    IrisButtonModule,
    IrisIconComponent,
  ],
  exports: [
    FAQAccordionComponent
  ]
})
export class FAQAccordionModule { }
